import { ReactNode } from 'react';

interface PageHeaderProps {
    title: string;
    subtitle?: string;
    actions?: ReactNode;
}

export default function PageHeader({
    title,
    subtitle,
    actions,
}: PageHeaderProps) {
    return (
        <div className="flex items-end justify-between gap-6 border-b border-[#dadbd5] pb-5 mb-8">
            <div>
                <h1 className="text-[28px] leading-tight font-semibold text-[#1c2620] tracking-tight">
                    {title}
                </h1>
                {subtitle && (
                    <p className="text-sm text-[#5a6259] mt-1.5 whitespace-pre-line">
                        {subtitle}
                    </p>
                )}
            </div>
            {actions && (
                <div className="flex items-center gap-2 flex-shrink-0">
                    {actions}
                </div>
            )}
        </div>
    );
}
